export enum UserTeamRoleEnum {
    LEAD = 1,
    MEMBER = 2,
    WATCHER = 3,
    TeamLeaderSubTeams = 4,
}
